import React, { useState, useEffect } from "react";
import Button from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";

import {
  Star,
  Smartphone,
  Globe,
  Zap,
  ArrowRight,
  MapPin,
  CheckCircle,
  CreditCard,
  Package,
  ChevronLeft,
  ChevronRight,
  UserPlus,
  Settings,
  Upload,
  Calculator,
  Menu,
  X,
  Printer,
  Monitor,
  Heart,
  Mail,
  PhoneCall,
  ArrowLeft,
} from "lucide-react";
import { Image } from "antd";
import { routes } from "../../Routes";
import { useNavigate } from "react-router";
import { RoughNotation } from "react-rough-notation";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/language-switcher";
import { store } from "../../Redux/store";
import LandingSubs from "./LandingSubs";
import { LeadFormComp } from "./LeadFormComp";
import { getUTMs } from "../../Utils/utm";
import Navbar from "./Navbar";

const LandingPage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageScale, setImageScale] = useState(0.7);
  const [scrollY, setScrollY] = useState(0);
  const { t, i18n } = useTranslation();

  const [modalTitle, setModalTitle] = useState(t("Talk to Sales"));
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = store.getState();
  const user_id = login.user;
  const is_retailer = login.user?.result?.is_retailer;
  const company_id = login.user?.result?.company_id;
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [onboardingDone, setOnboardingDone] = useState(null); // null = loading
  const [utms, setUtms] = useState({});

  useEffect(() => {
    const data = getUTMs();

    // remove null values
    // Object.keys(data).forEach(
    //   (key) => data[key] == null && delete data[key]
    // )
    Object.keys(data).forEach((key) => data[key]);

    setUtms(data);
  }, []);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    const fetchOnboarding = async () => {
      if (company_id) {
        const result = await CheckUserOnboarding(company_id);
        setOnboardingDone(result);
      }
    };
    if (company_id) {
      fetchOnboarding();
    }
  }, [company_id]);

  const CheckUserOnboarding = async (id) => {
    try {
      const res1 = await getUserOnboarding(id);

      if (res1?.result[0]?.status_code === 200) {
        let keys = res1?.result[0];

        return (
          keys?.update_inventory &&
          keys?.cashier_setup &&
          keys?.weighing_scale &&
          keys?.add_user &&
          keys?.delivery_company
        );
      }
      return false;
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      return false;
    }
  };

  const testimonials = [
    {
      name: "Ahmed Hassan",
      type: "Mini-Mart Owner",
      city: "Cairo",
      quote: "I started in 10 minutes — managing sales is now super easy!",
      rating: 5,
    },
    {
      name: "Fatma Ali",
      type: "Supermarket Manager",
      city: "Cairo",
      quote:
        "The Arabic interface makes it perfect for my customers and staff.",
      rating: 5,
    },
    {
      name: "Mohamed Salah",
      type: "Poultry Shop",
      city: "Cairo",
      quote: "Weighing machine integration saved me so much time every day.",
      rating: 5,
    },
    {
      name: "Nour Ibrahim",
      type: "Grocery Store",
      city: "Cairo",
      quote:
        "Customer credit tracking helps me manage my regular customers perfectly.",
      rating: 5,
    },
    {
      name: "Omar Khaled",
      type: "Grocery Store",
      city: "Cairo",
      quote: "Barcode scanning made checkout so much faster for my customers.",
      rating: 5,
    },
    {
      name: "Yasmin Ahmed",
      type: "Grocery Store",
      city: "Cairo",
      quote:
        "The inventory alerts prevent me from running out of important medicines.",
      rating: 5,
    },
    {
      name: "Hassan Mahmoud",
      type: "Grocery Store",
      city: "Cairo",
      quote:
        "Daily sales reports help me understand my business better than ever.",
      rating: 5,
    },
    {
      name: "Mona Sayed",
      type: "Grocery Store",
      city: "Cairo",
      quote: "Multi-payment support makes it easy for all my customers to pay.",
      rating: 5,
    },
    {
      name: "Karim Farouk",
      type: "Grocery Store",
      city: "Cairo",
      quote:
        "The offline mode ensures I never miss a sale, even during internet issues.",
      rating: 5,
    },
  ];

  const faqData = [
    {
      question: "How quickly can I set up Hisabak for my store?",
      answer:
        "You can set up Hisabak in just 10 minutes! Simply sign up with your phone number, select your shop type, upload your products via Excel, and start selling immediately.",
    },
    {
      question: "Does Hisabak work in Arabic?",
      answer:
        "Yes! Hisabak supports both Arabic and English interfaces, making it perfect for Egyptian retailers and their customers.",
    },
    {
      question: "Can I use Hisabak on my mobile phone?",
      answer:
        "Absolutely! Hisabak works seamlessly on Android mobile phones, tablets, and web browsers. You can sell anywhere, anytime.",
    },
    {
      question: "Does Hisabak work with weighing machines?",
      answer:
        "Yes, Hisabak is compatible with weighing machines, making it perfect for fresh produce, poultry shops, and businesses that sell by weight.",
    },
    {
      question: "Can I print receipts with Hisabak?",
      answer:
        "Yes, Hisabak supports receipt printing and you can even reprint previous receipts when needed. It works with most standard thermal printers.",
    },
    {
      question: "What if my internet connection is poor?",
      answer:
        "Hisabak has offline mode support, so you can continue selling even when your internet connection is unstable. Data syncs automatically when connection is restored.",
    },
    {
      question: "Can I import my existing product list?",
      answer:
        "Yes! You can easily import your products using Excel files, making the transition to Hisabak quick and hassle-free.",
    },
    {
      question: "Is there customer support available?",
      answer:
        "Yes, we provide WhatsApp support and have a comprehensive help center. Our team is dedicated to helping Egyptian retailers succeed.",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);

      const imageElement = document.getElementById("hero-image");
      if (imageElement) {
        const rect = imageElement.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom > 0;

        if (isInView) {
          const progress = Math.min(
            1,
            Math.max(0, (window.innerHeight - rect.top) / window.innerHeight),
          );
          const scale = 0.7 + progress * 0.3; // Scale from 0.7 to 1.0
          setImageScale(scale);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto-advance testimonials every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length,
    );
  };

  const openTalkToSalesModal = () => {
    setModalTitle(t("Talk to Sales"));
    setShowModal(true);
  };

  const openContactUsModal = () => {
    setModalTitle(t("Contact Us"));
    setShowModal(true);
  };
  const formSubmit = () => {
    navigate(routes.thankyou);
    // setIsSubmitted(true);
  };
  const formSubmitDone = () => {
    // setIsSubmitted(false);
    // setShowModal(false);
  };

  return (
    <div className="min-h-screen bg-background smooth-scroll">
      {/* Header */}
      {/* <header className="fixed top-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-b border-border z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
         
            <div className="flex items-center space-x-2">
              <div className="w-full flex flex-col items-center mx-auto justify-center">
                <Image
                  src={require("../../assets/Logo/hisabakLogo.png")}
                  alt="Hisabak logo"
                  width={130}
                  height={37}
                  preview={false}
                />
              </div>
            </div>

            <nav className="hidden md:flex items-center space-x-8">
              <a
                href="#features"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("Features")}
              </a>
              <a
                href="#how-it-works"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("How it Works")}
              </a>
              <a
                href="#testimonials"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("Testimonials")}
              </a>
              

               <a
                href="/aboutus"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("About Us")}
              </a>
              <a
                href="#faqs"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("FAQs")}
              </a>
            </nav>

            <div className="flex items-center space-x-4">
              <LanguageSwitcher loading={loading} setLoading={setLoading} />
              {user_id ? (
                <Button
                  className="hidden md:inline-flex bg-primary hover:bg-primary-dark text-primary-foreground"
                  onClick={() => {
                    if (is_retailer == false) {
                      navigate(routes.orders);
                    } else {
                      if (!onboardingDone) {
                        navigate(routes.onboarding);
                      } else {
                        navigate(routes.dashboard);
                      }
                    }
                  }}
                >
                  {t("Go to Dashboard")}
                </Button>
              ) : (
                <Button
                  className="hidden md:inline-flex bg-primary hover:bg-primary-dark text-primary-foreground"
                  onClick={() => navigate(routes.login)}
                  // onClick={() => window.open(`${process.env.REACT_APP_BASE_LANDING_URL}`, "_blank")}
                  // onClick={() => window.open("https://store.myginne.com/", "_blank")}
                >
                  {t("Sign Up / Login")}
                </Button>
              )}

         
              <button
                className="md:hidden p-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>

        
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-border bg-background">
              <nav className="flex flex-col space-y-2">
                <a
                  href="#features"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("Features")}
                </a>
                <a
                  href="#how-it-works"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("How it Works")}
                </a>
                <a
                  href="#testimonials"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("Testimonials")}
                </a>
                 <a
                href="/aboutus"
                className="text-foreground/80 hover:text-primary transition-colors"
              >
                {t("About Us")}
              </a>
              
                <div className="px-4 py-2 space-y-2">
                  <LanguageSwitcher loading={loading} setLoading={setLoading} />
                  {user_id ? (
                    <Button
                      className="w-full bg-primary hover:bg-primary-dark text-primary-foreground"
                      onClick={() => {
                        if (is_retailer == false) {
                          navigate(routes.orders);
                        } else {
                          navigate(routes.onboarding);
                        }
                      }}
                    >
                      {t("Go to Dashboard")}
                    </Button>
                  ) : (
                    <Button
                      className="w-full bg-primary hover:bg-primary-dark text-primary-foreground"
                      onClick={() => navigate(routes.login)}
                      // onClick={() =>
                      //   window.open(
                      //     `${process.env.REACT_APP_BASE_LANDING_URL}`,
                      //     "_blank",
                      //   )
                      // }
                    >
                      {t("Sign Up / Login")}
                    </Button>
                  )}
                </div>
              </nav>
            </div>
          )}
        </div>
      </header> */}

      <Navbar />
      {/* Hero Section */}
      <section className="min-h-screen pt-24 md:pt-36 relative overflow-hidden">
        <div
          className="absolute top-1/3 left-0 w-1/3 h-2/3 opacity-70 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(147, 197, 253, 0.8) 0%, rgba(147, 197, 253, 0.4) 50%, transparent 70%)",
            borderRadius: "0 100% 100% 0",
            transform: "translate(-20%, 0)",
          }}
        />
        <div
          className="absolute top-1/3 right-0 w-1/3 h-2/3 opacity-70 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(254, 240, 138, 0.8) 0%, rgba(254, 240, 138, 0.4) 50%, transparent 70%)",
            borderRadius: "100% 0 0 100%",
            transform: "translate(20%, 0)",
          }}
        />
        <div className="hidden md:block">
          <div className="absolute left-[-2rem] top-48 md:left-[-2rem] md:top-48">
            <img
              src={require("../../assets/Images/YellowArrow.png")}
              alt="Hisabak Devices - POS System"
              className="w-[300px] h-auto"
            />
          </div>
        </div>
        <div className="hidden md:block">
          <div className="absolute right-[0px] top-32 md:right-[0px] md:top-32">
            <img
              src={require("../../assets/Images/GreyArrow.png")}
              alt="Hisabak Devices - POS System"
              className="w-[100px] h-auto"
            />
          </div>
        </div>

        <div className="container mx-auto px-4 h-full pb-5">
          <div className="flex flex-col items-center justify-center min-h-[80vh] text-center relative">
            <div className="space-y-5 md:space-y-8 max-w-4xl mx-auto">
              <h4 className="text-2xl md:text-4xl lg:text-5xl font-semibold text-foreground !leading-[1.4]">
                {t("The Smartest")}{" "}
                <span className="relative">
                  <RoughNotation
                    type="underline"
                    color="#86efac"
                    show={true}
                    padding={isMobile ? -2 : -10}
                    strokeWidth={isMobile ? 6 : 9}
                    iterations={2}
                    customElement="span"
                  >
                    <span style={{ display: "inline" }}>{t("Cashier")}</span>
                  </RoughNotation>
                </span>{" "}
                {t("&")}
                <br />
                <span className="relative">
                  <RoughNotation
                    type="underline"
                    color="#86efac"
                    show={true}
                    padding={isMobile ? -2 : -10}
                    strokeWidth={isMobile ? 6 : 9}
                    iterations={2}
                    customElement="span"
                  >
                    <span style={{ display: "inline" }}>{t("Store")}</span>
                  </RoughNotation>
                </span>{" "}
                {t("Management System.")}
              </h4>

              <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed max-w-[90%] sm:max-w-xl md:max-w-2xl mx-auto w-full px-4">
                {t(
                  "Start your shop in just 10 minutes — manage inventory, track sales, print receipts & more.",
                )}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Button
                  className="bg-[#FCC71D] hover:bg-[#FCC71D] text-black font-medium px-8 py-3 rounded-lg text-lg shadow-lg hover:shadow-xl transition-all duration-200"
                  onClick={openTalkToSalesModal}
                >
                  {t("Get Started")}
                  {i18n.language == "ar" ? (
                    <ArrowLeft className="ml-2 w-5 h-5" />
                  ) : (
                    <ArrowRight className="ml-2 w-5 h-5" />
                  )}
                </Button>
                {/* <button className="flex items-center text-foreground hover:text-primary transition-colors duration-200 text-lg font-medium">
                  <Play className="mr-2 w-5 h-5" />
                  {t("Watch a demo")}
                </button> */}
              </div>
            </div>

            <div className="mt-8 relative max-w-4xl mx-auto">
              <img
                id="hero-image"
                src={require("../../assets/Images/LandingPageBannerImages.png")}
                alt="Hisabak Devices - POS System"
                className="w-full h-auto"
                // className="w-full h-auto rounded-2xl shadow-2xl"
                style={{
                  transform: `scale(${imageScale})`,
                  transition: "transform 0.1s ease-out",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Why Hisabak? */}
      <section className="py-10 md:py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4">
              {t("Built for")}{" "}
              <span className="text-gradient">{t("Egyptian Retailers.")}</span>{" "}
              {t("Trusted by")}{" "}
              <span className="text-gradient">{t("100s of Stores.")}</span>
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t(
                "Everything you need to succeed, built specifically for the Egyptian market",
              )}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8 max-w-6xl mx-auto">
            {[
              {
                icon: Monitor,
                title: "Easy to Use, Zero Training",
                description: "Start selling immediately",
              },
              {
                icon: Globe,
                title: "Arabic & English Interface",
                description: "Serve all customers",
              },
              {
                icon: Smartphone,
                title: "Works on Tablet, Mobile, Desktop",
                description: "Sell anywhere",
              },
              {
                icon: Printer,
                title: "Receipt Printing, Inventory, Customers",
                description: "All-in-one solution",
              },
              {
                icon: Package,
                title: "Weighing Machine Compatible",
                description: "Perfect for fresh products",
              },
              {
                icon: Zap,
                title: "Fast 10-Minute Setup",
                description: "From signup to first sale",
              },
            ].map((feature, index) => (
              <Card
                key={index}
                className="card-hover bg-card border border-border"
              >
                <CardContent className="p-2 md:p-6 text-center">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <feature.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="font-semibold text-sm md:text-lg mb-2 text-foreground">
                    {t(feature.title)}
                  </h3>
                  <p className="text-xs md:text-xltext-muted-foreground">
                    {t(feature.description)}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: All-in-One Features */}
      <section id="features" className="py-0 md:py-10 section-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center mb-5 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-1 md:mb-4">
              <span className="text-gradient">{t("All-in-One")}</span>{" "}
              {t("Features")}
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t("Everything you need to run your retail business efficiently")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-12 max-w-6xl mx-auto">
            {/* Store Management */}
            <Card className="card-hover bg-card border border-border p-6 text-center">
              <CardContent className="p-0">
                <div className="space-y-6">
                  <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-6 flex items-center">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mr-3">
                      <Package className="h-6 w-6 text-primary" />
                    </div>
                    {t("Store Management")}
                  </h3>

                  <div className="space-y-4">
                    {[
                      "Smart Inventory Tracking",
                      "Online Orders Management",
                      "Vendor & Supplier Tracking",
                      "Excel Import/Export",
                      "Multi-location Support",
                      "Automated Reorder Alerts",
                    ].map((feature, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <CheckCircle className="h-5 w-5 text-primary flex-shrink-0" />
                        <span className="text-foreground px-4">
                          {t(feature)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="card-hover bg-card border border-border p-6 text-center">
              <CardContent className="p-0">
                {/* Cashier Features */}
                <div className="space-y-6">
                  <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-6 flex items-center">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mr-3">
                      <CreditCard className="h-6 w-6 text-primary" />
                    </div>
                    {t("Cashier Features")}
                  </h3>

                  <div className="space-y-4">
                    {[
                      "Barcode Scanning & Billing",
                      "Customer Credit Tracking",
                      "Real-time Sales Dashboard",
                      "Receipt Printing & Reprint",
                      "Offline Mode Support",
                      "Multi-payment Methods",
                    ].map((feature, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <CheckCircle className="h-5 w-5 text-primary flex-shrink-0" />
                        <span className="text-foreground px-4">
                          {t(feature)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Section 4: How it Works */}
      <section id="how-it-works" className="py-12 md:py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-1 md:mb-4">
              {t("From Sign-Up to")}{" "}
              <span className="text-gradient">
                {t("First Sale in 4 Steps")}
              </span>
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t("Get your store up and running in minutes")}
            </p>
          </div>

          {/* Progress Flow */}
          <div className="max-w-6xl mx-auto">
            {/* Progress Bar */}
            <div className="relative mb-12">
              <div className="hidden md:block absolute top-8 left-0 right-0 h-1 bg-muted rounded-full">
                <div className="h-full bg-primary rounded-full w-full"></div>
              </div>

              <div className="relative grid md:grid-cols-4 gap-8">
                {[
                  {
                    step: 1,
                    title: "Sign up with phone number",
                    icon: UserPlus,
                    description: "Quick registration process",
                  },
                  {
                    step: 2,
                    title: "Select shop type",
                    icon: Settings,
                    description: "Choose your business model",
                  },
                  {
                    step: 3,
                    title: "Upload products via Excel",
                    icon: Upload,
                    description: "Import your inventory easily",
                  },
                  {
                    step: 4,
                    title: "Sell with Cashier App",
                    icon: Calculator,
                    description: "Begin processing sales",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="relative w-full sm:w-[220px] md:w-[250px] lg:w-[280px]"
                  >
                    {/* Step Circle */}
                    <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg">
                      <item.icon className="h-8 w-8 text-primary-foreground" />
                    </div>

                    {/* Content Card */}
                    <Card className="card-hover bg-card border border-border p-6 text-center">
                      <CardContent className="p-0">
                        <h3 className="font-semibold text-foreground mb-2">
                          {t(item.title)}
                        </h3>
                        <p className="text-sm text-muted-foreground">
                          {t(item.description)}
                        </p>
                      </CardContent>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="text-center md:mt-12">
            <p className="text-muted-foreground">
              <span className="font-medium">{t("Works on:")}</span>{" "}
              {t("Android mobile, tablet, or browser")}
            </p>
          </div>
        </div>
      </section>

      {/* Section 5: Plans & Pricing */}
      <section id="pricing" className="md:py-10 section-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center mb-7 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-2 md:mb-4 text-gradient">
              {t("Plans & Pricing")}
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t("Choose the perfect plan for your business")}
            </p>
          </div>
          <LandingSubs />
        </div>
      </section>
      {/* Section 6: Testimonials */}
      <section id="testimonials" className="py-10 md:py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4">
              {t("Real Retailers.")}{" "}
              <span className="text-gradient">{t("Real Stories.")}</span>
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t("See what our customers say about Hisabak")}
            </p>
          </div>

          <div className="max-w-6xl mx-auto relative">
            {/* Navigation Arrows */}
            <Button
              variant="outline"
              size="icon"
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-background border-border hover:bg-muted"
              onClick={prevTestimonial}
            >
              <ChevronLeft className="h-4 w-4" />
            </Button>

            <Button
              variant="outline"
              size="icon"
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-background border-border hover:bg-muted"
              onClick={nextTestimonial}
            >
              <ChevronRight className="h-4 w-4" />
            </Button>

            {/* Three Testimonials Grid */}
            <div className="mx-4 md:mx-12">
              {/* On Desktop: Show 3 testimonials */}
              <div className="hidden md:grid md:grid-cols-3 gap-6">
                {[0, 1, 2].map((offset) => {
                  const testimonialIndex =
                    (currentTestimonial + offset) % testimonials.length;
                  const testimonial = testimonials[testimonialIndex];

                  return (
                    <Card
                      key={`desktop-${testimonialIndex}`}
                      className="bg-card border border-border p-6 text-center"
                    >
                      <CardContent className="p-0">
                        <div className="flex justify-center mb-4">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <Star
                              key={i}
                              className="h-4 w-4 text-accent fill-current"
                            />
                          ))}
                        </div>
                        <blockquote className="text-lg text-foreground mb-4 italic">
                          "{t(testimonial.quote)}"
                        </blockquote>
                        <div className="text-muted-foreground">
                          <p className="font-semibold text-sm">
                            {t(testimonial.name)}
                          </p>
                          <p className="text-xs">
                            {t(testimonial.type)}, {t(testimonial.city)}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>

              {/* On Mobile: Show only 1 testimonial */}
              <div className="block md:hidden">
                {(() => {
                  const testimonial =
                    testimonials[currentTestimonial % testimonials.length];
                  return (
                    <Card
                      key={`mobile-${currentTestimonial}`}
                      className="bg-card border border-border p-6 text-center"
                    >
                      <CardContent className="p-0">
                        <div className="flex justify-center mb-4">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <Star
                              key={i}
                              className="h-4 w-4 text-accent fill-current"
                            />
                          ))}
                        </div>
                        <blockquote className="text-lg text-foreground mb-4 italic">
                          "{t(testimonial.quote)}"
                        </blockquote>
                        <div className="text-muted-foreground">
                          <p className="font-semibold text-sm">
                            {testimonial.name}
                          </p>
                          <p className="text-xs">
                            {testimonial.type}, {testimonial.city}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Retailer Video Section */}
      <section className="py-10 md:py-20 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="items-center max-w-6xl mx-auto w-full">
            <h3 className="text-2xl md:text-3xl font-semibold mb-10 text-center text-primary">
              {t("Why Hisabak?")}
            </h3>
          </div>

          <div className="grid lg:grid-cols-10 gap-12 items-center max-w-6xl mx-auto">
            {/* Video - 60% */}
            <div className="lg:col-span-6">
              <div className="relative aspect-video rounded-2xl overflow-hidden shadow-xl">
                <iframe
                  src="https://www.youtube.com/embed/OTe_QtobOuM"
                  title="Hisabak Retailer Success Story"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Content - 30% */}
            <div className="lg:col-span-4">
              <div className="space-y-6">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                  {t("Discover How Hisabak")}{" "}
                  <span className="text-gradient">{t("Transforms")}</span>{" "}
                  {t("Retail Operations")}
                </h2>

                <p className="text-muted-foreground text-lg leading-relaxed">
                  {t(
                    "Discover how myGINNE is empowering retailers across Egypt to run smarter, faster, and more efficiently. In this video, one of our valued store owners shares how our Cashier and store management system transformed their daily operations — from managing inventory to selling products seamlessly.",
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 7: Trust & Reach */}
      <section className="py-10 md:py-20 section-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center mb-6 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4">
              <span className="text-gradient">{t("Trusted Across Egypt")}</span>
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t("Join thousands of successful retailers")}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center max-w-4xl mx-auto px-4">
            {/* Card 1 */}
            <Card className="bg-card border border-border p-4 sm:p-6 md:p-8 text-center">
              <CardContent className="p-0">
                <MapPin className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-primary mx-auto mb-3" />
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary mb-1">
                  5000+
                </h3>
                <p className="text-sm sm:text-base md:text-lg text-muted-foreground mb-3">
                  {t("Stores Across Egypt")}
                </p>
                <div className="flex justify-center space-x-2 text-xs sm:text-sm text-muted-foreground">
                  <span>{t("Cairo")}</span>
                  <span>•</span>
                  <span>{t("Alexandria")}</span>
                  <span>•</span>
                  <span>{t("Giza")}</span>
                  <span>•</span>
                  <span>{t("More")}</span>
                </div>
              </CardContent>
            </Card>

            {/* Card 2 */}
            <Card className="bg-card border border-border p-4 sm:p-6 md:p-8 text-center">
              <CardContent className="p-0">
                <Heart className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-primary mx-auto mb-3" />
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary mb-1">
                  50,000+
                </h3>
                <p className="text-sm sm:text-base md:text-lg text-muted-foreground mb-3">
                  {t("Orders Delivered")}
                </p>
                <div className="flex justify-center items-center space-x-1 sm:space-x-2">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-accent fill-current"
                    />
                  ))}
                  <span className="ml-2 text-xs sm:text-sm text-muted-foreground">
                    4.9/5 {t("Rating")}
                  </span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Section 8: FAQs */}
      <section id="faqs" className="py-10 md:py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-6 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4">
              {t("Frequently Asked Questions")}
            </h2>
            <p className="text-md md:text-xl text-muted-foreground">
              {t(
                "Answers to common questions about myGINNE and retail management",
              )}
            </p>
          </div>

          <Accordion type="single" collapsible>
            {faqData.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger>{t(faq.question)}</AccordionTrigger>
                <AccordionContent>
                  <p className="text-muted-foreground">{t(faq.answer)}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Section 9: Final CTA */}
      <section className="pb-24 pt-6 md:pt-10 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4">
              {t("Start Free –")}{" "}
              <span className="text-gradient">{t("No Setup Charges")}</span>
            </h2>
            <p className="text-md md:text-xl text-muted-foreground mb-8">
              {t("Join thousands of Egyptian retailers already using Hisabak")}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <Button
                className="btn-hero group"
                onClick={() => navigate(routes.login)}
              >
                {t("Sign Up Now")}
                {i18n.language == "ar" ? (
                  <ArrowLeft className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                ) : (
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                )}
              </Button>
              <Button
                className="btn-hero-outline"
                onClick={openTalkToSalesModal}
              >
                {t("Talk to Sales")}
              </Button>
              {/* <Button variant="outline" className="border-primary text-primary">
                <Play className="mr-2 w-4 h-4" />
                {t("Watch Demo")}
              </Button> */}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-card border-t border-border py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:[grid-template-columns:1.5fr_1fr_1fr_1fr] gap-8">
            <div className="space-y-1text-sm text-muted-foreground">
              <div className="flex items-center space-x-2 mb-3">
                <Image
                  src={require("../../assets/Logo/hisabakLogo.png")}
                  alt="Hisabak logo"
                 width={130}
                  height={37}
                  preview={false}
                />
              </div>
              <div
                className={`text-[12px] mb-1 ${
                  i18n.language === "ar" ? "text-right" : "text-left"
                }`}
                dir="ltr"
              >
                {t(
                  "14 Prince Waleed Bin-Thinyan Al-Saud, Sheraton Al Matar, El Nozha, Cairo Governorate 11799",
                )}
              </div>

              <div
                className={`flex items-center text-[12px] mb-1 ${
                  i18n.language === "ar" ? "justify-end" : "justify-start"
                }`}
                dir="ltr"
              >
                <PhoneCall
                  className={`${
                    i18n.language === "ar" ? "mr-2" : "mr-2"
                  } w-4 h-4 text-primary`}
                />
                +20 100 450 5666
              </div>

              <div
                className={`flex items-center text-[12px] mb-1 ${
                  i18n.language === "ar" ? "justify-end" : "justify-start"
                }`}
                dir="ltr"
              >
                <Mail
                  className={`${
                    i18n.language === "ar" ? "mr-2" : "mr-2"
                  } w-4 h-4 text-primary`}
                />
                support@myginne.com
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-foreground">
                {t("Company")}
              </h4>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  <a
                    href="https://myginne.com/"
                    className="hover:text-primary transition-colors"
                    target="blank"
                  >
                    {t("About Us")}
                  </a>
                </p>
                <p>
                  <a
                    href="https://myginne.com/privacy-policy.html"
                    className="hover:text-primary transition-colors"
                    target="blank"
                  >
                    {t("Privacy Policy")}
                  </a>
                </p>
                <p>
                  <a
                    href="https://myginne.com/refund-and-cancellation-policy"
                    target="blank"
                    className="hover:text-primary transition-colors"
                  >
                    {t("Refund & Cancellation Policy")}
                  </a>
                </p>
                <p>
                  <a
                    href="https://myginne.com/shipping-and-delivery-policy"
                    target="blank"
                    className="hover:text-primary transition-colors"
                  >
                    {t("Shipping & Delivery Policy")}
                  </a>
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-foreground">
                {t("Support")}
              </h4>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  <a
                    href="https://api.whatsapp.com/send/?phone=201004505666&text&type=phone_number&app_absent=0"
                    className="hover:text-primary transition-colors"
                    target="blank"
                  >
                    {t("WhatsApp Support")}
                  </a>
                </p>
                <p>
                  <button
                    onClick={openContactUsModal}
                    className="hover:text-primary transition-colors text-left"
                  >
                    {t("Contact Us")}
                  </button>
                </p>
                {/* <p>
                  <a href="#" className="hover:text-primary transition-colors">
                    {t("Training Videos")}
                  </a>
                </p> */}
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-foreground">
                {t("Download Apps")}
              </h4>
              <div className="space-y-3">
                <a
                  href="https://play.google.com/store/apps/details?id=com.myginne.com.storeapp&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <Button
                    variant="new"
                    className="w-full justify-start border-none"
                  >
                    {/* <Smartphone className="mr-2 w-4 h-4" /> */}
                    <Image
                      src={require("../../assets/Logo/hisabakstore.webp")}
                      alt="Hisabak logo"
                      width={37}
                      height={37}
                      preview={false}
                      style={{ borderRadius: "8px" }}
                    />
                    {t("Hisabak Store")}
                  </Button>
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=com.myginne.app&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <Button
                    variant="new"
                    className="w-full justify-start border-none"
                  >
                    {/* <Smartphone className="mr-2 w-4 h-4" /> */}
                    <Image
                      src={require("../../assets/Logo/hisabakpos.webp")}
                      alt="Hisabak logo"
                      width={37}
                      height={37}
                      preview={false}
                      style={{ borderRadius: "8px" }}
                    />
                    {t("Hisabak POS")}
                  </Button>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-border pt-8 mt-8 text-center text-muted-foreground">
            <p>
              {t(
                "© 2026 Hisabak. All rights reserved. Made for Egyptian retailers with ❤️",
              )}
            </p>
          </div>
        </div>
      </footer>

      {/* Talk to Sales Modal */}
      <Dialog open={showModal} onOpenChange={setShowModal}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>{modalTitle}</DialogTitle>
          </DialogHeader>
          <div className="relative min-h-[430px] overflow-hidden">
            {/* {isSubmitted ? (
              <div
                className="absolute inset-0 flex flex-col items-center justify-center space-y-6 animate-fade-in"
                style={{ animationDelay: "150ms" }}
              >
                <div
                  className="animate-scale-in"
                  style={{ animationDelay: "300ms" }}
                >
                  <div className="relative mb-8">
                    <CheckCircle className="w-24 h-24 text-green-500 animate-pulse" />
                    <div className="absolute inset-0 w-24 h-24 rounded-full bg-green-500/20 animate-ping"></div>
                  </div>
                </div>
                <p
                  className="text-center text-lg font-medium animate-fade-in text-foreground"
                  style={{ animationDelay: "600ms" }}
                >
                  {t("myGINNE will contact you soon!")}
                </p>
              </div>
            ) : ( */}
            <LeadFormComp
              formSubmit={formSubmit}
              // formSubmitDone={formSubmitDone}
              utms={utms}
            />
            {/* )} */}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LandingPage;
